/******************************************************************************\
 * :$
 *
 * Copyright(c) 2021 SAS Institute Inc., Cary, NC, USA. All Rights Reserved.
 *
 * Name: Dashboard
 *
 * Purpose:
 *
 * Author: craig (Craig.Simpson@sas.com)
 *
 * Support: SAS(r) Solutions OnDemand
 *
 * Input:
 *
 * Output:
 *
 * Parameters: (if applicable)
 *
 * Dependencies/Assumptions:
 *
 * Usage:
 *
 * History:
 * ddmmmyyyy userid description (Change Code)
 * 11Nov2021 craig File created.
 \******************************************************************************/
import React, {useEffect, useMemo, useState} from "react";
import "./Dashboard.css";
import '../../../App.css';
import {Col, Container, Row, Form, Button} from "react-bootstrap";
import {GSContext} from "../../../context/context";
import {getDataGet} from "../../../models/data/Data";
import CountdownTimer from "../../../components/countdown/Countdowntimer";
import {ITeam} from "../../../models/application/IApplication";
import {DashboardTable} from "../../../components/dashboard/DashboardTable";
import {Link} from "react-router-dom";

export const Dashboard: React.FC = (props) => {

    const [sessionUser] = React.useContext(GSContext);
    const [teams, setTeams] = useState<ITeam[]>([]);
    const [activeTeam, setActiveTeam] = useState<ITeam>();
    const [selectedTeam, setSelectedTeam] = useState<string>("");

    // function useAsync(asyncFn, onSuccess) {
    useMemo(() => {
        const teamsURL = process.env.REACT_APP_API_URL + "/api/dashboard";

        getDataGet(teamsURL).then(response => {
            if (response !== null) {
                setTeams(response);
                setActiveTeam(response[0]);
            }
        })
    }, [])

    const handleComments = (event: React.FormEvent<HTMLButtonElement>) => {
        const commentsURL = process.env.REACT_APP_API_URL + "/api/reviewercomments/" + activeTeam?.TeamID;
        //const commentsURL = process.env.REACT_APP_API_URL + "/api/dashboard";
        //console.log(commentsURL);
        getDataGet(commentsURL).then(response => {
            //console.log(response);
        })

    }

    const buildTeamsSelect = () => {
        if (teams.length > 1) {
            return <Form className={"form-layout"} noValidate={true}>
                <Row className="mb-3">
                    <Form.Group as={Col} className={"col-left"} controlId={"formApplication"}>
                        <Form.Label>Select Team *</Form.Label>
                        <Form.Control as={"select"} className="text-mid-width"
                                      value={selectedTeam}
                                      onChange={handleTeamSelect}>
                            {buildTeamsList()}
                        </Form.Control>
                    </Form.Group>
                </Row>
            </Form>
        }
        return <div/>

    }

    const buildTeamsList = () => {
        let optionTemplate = teams.map(v => (
            <option key={v.TeamID} value={v.TeamID}>{v.TeamName}</option>
        ));

        return optionTemplate;
    }

    const handleTeamSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
        const team = teams?.find(e => e.TeamID.toString() === event.target.value);
        if (team !== undefined) {
            setSelectedTeam(event.target.value);
            setActiveTeam(team);
        }
    }

    const showDaysLeftMessage = () => {

        const today = new Date();
        if (activeTeam?.StartDate !== undefined && activeTeam?.EndDate !== undefined) {
            const day = new Date(activeTeam?.EndDate).getDay();
            if (today < activeTeam?.StartDate) {
                return (
                    <h2>Team will start on {new Date(activeTeam?.StartDate).toLocaleDateString('en-us', {weekday:"long", year:"numeric", month:"short", day:"numeric"})}</h2>
                );
            } else if (activeTeam?.StartDate <= activeTeam?.EndDate) {
                //get the number of days
                const endDate: Date = new Date(activeTeam?.EndDate);
                //const timeInMilisec:number = endDate.getTime() - today.getTime();
                //const daysBetweenDates:number = Math.ceil(timeInMilisec / (1000 * 60 * 60 * 24));
                return (
                    <CountdownTimer targetDate={endDate} header={"Days to Submit Feedback"}/>
                )
            } else if (today > activeTeam?.StartDate) {
                return (
                    <h2>Team is group review date: {new Date(activeTeam?.EndDate).toLocaleDateString('en-us', {weekday:"long", year:"numeric", month:"short", day:"numeric"})}</h2>
                )
            }

        }
        return <></>
    }

    const showTeamComments = () => {
        if (activeTeam?.StartDate !== undefined && activeTeam?.EndDate !== undefined) {
            const today = new Date();
            const endDate = new Date(activeTeam?.EndDate)
            if (today > endDate) {
                return (
                    <Row>
                        <Col className={"all-comments-link"}>
                            {/*<Button onClick={handleComments}>Download Reviewer Comments</Button>*/}
                            <a href={"/TeamComments/" + activeTeam?.TeamID}>View Reviewer Comments</a>
                        </Col>
                    </Row>
                )
            }
        }
    }


    return (
        <Container className="form-container" fluid>
            <Row>
                <Col className="page-title">
                    <h1>Dashboard ({activeTeam?.TeamName})</h1>
                </Col>
            </Row>
            {buildTeamsSelect()}
            <Row className={"countdown"}>
                <Col className={"section-object"}>
                    {showDaysLeftMessage()}
                </Col>
            </Row>
            {showTeamComments()}
            <Row className={"countdown"}>
                <Col className="page-title">
                    <h2>{activeTeam?.TeamName} Team Group
                        Meeting: {new Date(activeTeam?.GroupDate ?? '').toLocaleDateString('en-us', {weekday:"long", year:"numeric", month:"short", day:"numeric"})}</h2>
                </Col>
            </Row>
            <Row>
                {DashboardTable(sessionUser, activeTeam)}
            </Row>
        </Container>
    );
}